import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
export function FloatingCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex flex-col items-center gap-2 transition-transform duration-500 ease-[cubic-bezier(0.175,0.885,0.32,1.275)] ${isVisible ? 'translate-y-0' : 'translate-y-[150px]'}`} data-id="element-23">
      <a href="https://pay.hotmart.com/S104868471X" target="_blank" rel="noopener noreferrer" className="btn-sweep inline-flex items-center justify-center gap-2.5 bg-gradient-to-r from-accent via-accent-light to-accent-dark bg-[length:300%_100%] animate-btn-gradient text-primary text-base font-extrabold py-4 px-9 rounded-full border-none cursor-pointer no-underline shadow-[0_8px_32px_rgba(232,160,32,0.4)] whitespace-nowrap hover:scale-105 transition-transform" data-id="element-24">
        <Zap className="w-5 h-5" data-id="element-25" />
        ¡Quiero apagar el fuego! — 12 USD
      </a>
      <span className="bg-primary/90 border border-accent/20 text-text-muted text-xs py-1 px-3.5 rounded-full backdrop-blur-md" data-id="element-26">
        Precio normal 120 USD — Garantía 7 días
      </span>
    </div>;
}